import request from '@/utils/request'
//get
export function getTransaction(){
    return request({
        url: '/transaction/',
        method:'GET'
    })
}
export function getTransactionBySearch(params){
    return request({
      url: `/transaction/${params}`,
      method:'GET'
    })
  }
  export function getAdminTransactionBySearch(params){
    return request({
      url: `/transaction/admin_list/${params}`,
      method:'GET'
    })
  }


// WEBPACK FOOTER //
// ./src/api/transaction.js